export default __webpack_public_path__ + "zbrush.50277d90.png";